__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/172cc6f09e145ef5a7222c0f646a52f3d1e0839d/_next/";